<dv-dynamic-form
  [elements]="tab.elements | translateElements"
  [formGroup]="formGroup"
  formTitle="{{ 'Vehicle.AdjustMileage' | translate | uppercase }}">
</dv-dynamic-form>
<dv-save-panel
  labelCancel=""
  [disableSave]="!formGroup.dirty || !formGroup.valid"
  labelSave="{{ 'General.Save' | translate }}"
  (save)="onSave()">
  <span>Not saved*</span>
</dv-save-panel>
